import { Flex, Icon, IconButton } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import icons from 'shared/icons';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import { TGlobalCategoriesHooks } from './useGlobalCategories';
import { DeleteIcon } from '@chakra-ui/icons';

interface IColorsToolbarProps {
    table: Table<any>;
    isGlobalCategoriesLoading: TGlobalCategoriesHooks['isGlobalCategoriesLoading'];
    handleOpenModal: TGlobalCategoriesHooks['handleOpenModal'];
    setDataToSubmit: TGlobalCategoriesHooks['setDataToSubmit'];
    selectedCategories: TGlobalCategoriesHooks['selectedCategories'];
    handleDelete: TGlobalCategoriesHooks['handleDelete'];
    setAvailableCategories: TGlobalCategoriesHooks['setAvailableCategories'];
    clientCategories: TGlobalCategoriesHooks['clientCategories'];
    isExportLoading: TGlobalCategoriesHooks['isExportLoading'];
    isExportFetching: TGlobalCategoriesHooks['isExportFetching'];
    handleExportCategories: TGlobalCategoriesHooks['handleExportCategories'];
}

const GlobalCategoriesToolbar = ({
    table,
    isGlobalCategoriesLoading,
    handleOpenModal,
    setDataToSubmit,
    setAvailableCategories,
    isExportLoading,
    isExportFetching,
    handleExportCategories,
    selectedCategories,
    clientCategories,
    handleDelete,
}: IColorsToolbarProps) => {
    const { setGlobalFilter } = table;
    const PlusIcon = icons.plus;
    const DownloadIcon = icons.download;
    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
            <IconButton
                onClick={() => {
                    setDataToSubmit({ client_categories: [] });
                    if (clientCategories) setAvailableCategories(clientCategories);
                    handleOpenModal('add');
                }}
                {...iconTableStyle}
                aria-label="add alias"
                isDisabled={isGlobalCategoriesLoading}
                size="sm"
                icon={<Icon as={PlusIcon} />}
            />
            <IconButton
                {...iconTableStyle}
                aria-label="download excel"
                isLoading={isExportLoading || isExportFetching}
                onClick={handleExportCategories}
                size="sm"
                icon={<DownloadIcon />}
            />
            <IconButton
                size="sm"
                isDisabled={selectedCategories.length === 0}
                {...iconTableStyle}
                onClick={() => handleDelete(true)}
                aria-label="bulk delete"
                icon={<Icon as={DeleteIcon} />}
            />
        </Flex>
    );
};

export default GlobalCategoriesToolbar;
